import type { Asserts } from 'yup';

import { contractSchema as pkwContractSchema } from '@/features/Sparten/pkw/schema/contractSchema';
import { genericStoreFactory } from '@/utils/genericStoreFactory/genericStoreFactory';

export const contractSchema = pkwContractSchema;

export type ContractStore = Asserts<typeof contractSchema>;

export const usePkwContractStore = genericStoreFactory(
  () => contractSchema.getDefault() as ContractStore,
  'PkwContractStore',
);
